import styled from "styled-components";
import {
  Input as AntInput,
} from "antd";

export const InputContainer = styled.div`

  .float-label {
  position: relative;
}

.label {
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 24px;
  top: 14px;
  transition: 0.2s ease all;
}

.as-placeholder {
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #7E8485;
  z-index: 1;
}

.as-label {
  z-index: 20;
  top: -8px;
  background: white;
  padding: 0 4px;
  margin-left: -4px;
  color:  #535B5D;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

`

export const Input = styled(AntInput.Password)`
  border-radius: 34px;
  border: 1.5px solid #DEDEDE;
  height: 52px;
  
  input {
    font-size: 16px !important ;
    text-align: left !important;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .ant-input {
  font-size: 17px !important;
}

  /* Adjust placeholder styles */
  /* &::placeholder {
      color: red;
      opacity: 0.6;
  } */

  &&&{
    padding-left: 24px;
  }
`